// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 3H18V5H13V18C13 20.2091 11.2091 22 9 22C6.79086 22 5 20.2091 5 18C5 15.7909 6.79086 14 9 14C9.72857 14 10.4117 14.1948 11 14.5351V3Z"}}]};

const Music2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'music-2-filled',
    ref,
    icon: element,
  },
));

Music2FilledIcon.displayName = 'Music2FilledIcon';

export default Music2FilledIcon;
